import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Attachment } from 'src/app/models/index';
import {
  CommonService,
  LoadService,
  SiteService
} from 'src/app/services/index';
import { ActionModeEnum, AlertService, Constants } from 'src/app/shared';

@Component({
  selector: 'app-add-node-detail-modal',
  templateUrl: './add-node-detail-modal.component.html',
  styleUrls: ['./add-node-detail-modal.component.scss']
})
export class AddNodeDetailModalComponent
  implements OnInit, AfterViewChecked, AfterViewInit
{
  public selectedDivID: string;
  public siteId: string;
  public immediateChildNodes: any;

  immediateChildEntites = [];
  loadAttachment: Attachment = new Attachment();
  sensorConnectedToGenericLoad: any;
  formData: UntypedFormGroup;
  nodeDetails: any;
  actionMode: ActionModeEnum = ActionModeEnum.Creating;
  get getActionModeEnum() {
    return ActionModeEnum;
  }
  requiredValidators = [Validators.required];
  node: any;
  loads: any;

  entity = [
    { text: 'level', value: 'Level' },
    { text: 'sensor', value: 'Sensor' },
    { text: 'meter', value: 'Meter' }
  ];
  kpiType: string[];
  parameters: any;

  constructor(
    private dialogRef: MatDialogRef<AddNodeDetailModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: UntypedFormBuilder,
    private loadService: LoadService,
    private commonService: CommonService,
    private cdRef: ChangeDetectorRef,
    private siteService: SiteService,
    private alertService: AlertService
  ) {
    this.parameters = [];
    this.loads = [];

    this.initNodeDetailsObj();
    if (this.data) {
      if (this.data.nodeDetail.actionMode === ActionModeEnum.Editing) {
        this.nodeDetails = data.nodeDetail;
        this.actionMode = ActionModeEnum.Editing;
        this.nodeDetails.actionMode = this.actionMode;
      }
      this.siteId = data.siteId;
      this.immediateChildNodes = data.nodeDetail.immediateChildNodes;
      this.node = data.nodeData;
    }
  }

  ngOnInit() {
    this.formData = this.fb.group({
      nodeNameCtr: [
        '',
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(30),
          Validators.pattern('[a-zA-Z0-9_& ./:,-]*'),
          this.startWhitespace
        ]
      ],
      selectedEnityCtr: ['', [Validators.required]],
      selectedsensorRIdCtr: [''],
      selectedLoadEntityCtr: [''],
      level: ['', Validators.required],
      kpiName: [''],
      parameterType: ['']
    });
    this.getEntityList();
  }
  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }
  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }
  close(confirm: boolean) {
    this.dialogRef.close({ status: confirm, data: null });
  }
  private initNodeDetailsObj = () => {
    this.nodeDetails = {};
    this.nodeDetails.nodeId = new Date().getTime();
    this.nodeDetails.nodeName = null;
    this.nodeDetails.selectedEnity = '';
    this.nodeDetails.assignSensor = false;
    this.nodeDetails.sensorRIdForSelectedEnity = '';
    this.nodeDetails.actionMode = this.actionMode;
    this.nodeDetails.kpiName = '';
    this.nodeDetails.monitoredParameter = '';
    this.nodeDetails.loadID = '';
    this.nodeDetails.meterId = '';
    this.nodeDetails.level = ''; //entity type
    this.nodeDetails.selectedLoadEntity = '';
  };
  public addNodeLabel = () => {
    this.commonService.sendNodeTreeDetailSubject(this.nodeDetails);
    console.log('addNodeLabel', this.nodeDetails);
    this.dialogRef.close();
  };
  public delete = (e: any) => {
    e.preventDefault();
    this.nodeDetails.actionMode = ActionModeEnum.Deleting;
    this.commonService.sendNodeTreeDetailSubject(this.nodeDetails);
    this.dialogRef.close();
  };

  private removeAllValidatorCtr = () => {
    const selectedEnityCtr = this.formData.get('selectedEnityCtr');
    selectedEnityCtr.setValidators(null);
    selectedEnityCtr.updateValueAndValidity();
    const selectedsensorRIdCtr = this.formData.get('selectedsensorRIdCtr');
    selectedsensorRIdCtr.setValidators(null);
    selectedsensorRIdCtr.updateValueAndValidity();

    //meter
    const selectedLoadEntityCtr = this.formData.get('selectedLoadEntityCtr');
    selectedLoadEntityCtr.setValidators(null);
    selectedLoadEntityCtr.updateValueAndValidity();
    const parameterType = this.formData.get('parameterType');
    parameterType.setValidators(null);
    parameterType.updateValueAndValidity();
  };

  private setValidatorCtr = () => {
    const selectedEnityCtr = this.formData.get('selectedEnityCtr');
    selectedEnityCtr.setValidators(this.requiredValidators);
    selectedEnityCtr.updateValueAndValidity();
    const selectedsensorRIdCtr = this.formData.get('selectedsensorRIdCtr');
    selectedsensorRIdCtr.setValidators(this.requiredValidators);
    selectedsensorRIdCtr.updateValueAndValidity();
  };

  private setValidatorForMeter() {
    const selectedEnityCtr = this.formData.get('selectedLoadEntityCtr');
    selectedEnityCtr.setValidators(this.requiredValidators);
    selectedEnityCtr.updateValueAndValidity();
    const selectedsensorRIdCtr = this.formData.get('parameterType');
    selectedsensorRIdCtr.setValidators(this.requiredValidators);
    selectedsensorRIdCtr.updateValueAndValidity();
  }

  public getEntityList = () => {
    this.removeAllValidatorCtr();
    this.immediateChildEntites = this.immediateChildNodes;
    if (this.nodeDetails.level == 'sensor') {
      this.setValidatorCtr();
      const params = {
        siteID: this.siteId,
        type: Constants.LOAD_TYPE.GENERIC_OR_AREA_SPECIFIC_SENSOR.TYPE_VALUE
      };
      this.loadService
        .getLoadsbasedOnTypeAndSubType(params)
        .subscribe((data) => {
          const genericSensorLoadsForSite = [];
          if (data != null || data.length > 0) {
            for (let i = 0; i < data.length; i++) {
              genericSensorLoadsForSite.push({
                Title: data[i].name,
                RId: data[i].rId,
                loadId: data[i].loadId,
                nodeId: data[i].loadId
              });
            }
          }
          this.immediateChildEntites = genericSensorLoadsForSite;
        });
    } else if (this.nodeDetails.level == 'meter') {
      this.setValidatorForMeter();
      this.siteService
        .getNonHydraulicLoadsBySiteId(this.siteId)
        .subscribe((nonHydData) => {
          for (let i = 0; i < nonHydData.length; i++) {
            const load = nonHydData[i];
            nonHydData[i].paramArr = this.buildLoadParams(load, true);
          }
          this.loads = nonHydData;
        });
    } else {
      this.immediateChildEntites = this.immediateChildNodes;
    }
  };

  private buildLoadParams = (load: any, forAlertConfig: boolean) => {
    let loadParamArr = [];
    let allElectricalParams = [];
    let otherParams = [];
    const allHarmonicParams = [
      { text: 'thd_ia', value: 'thd_ia' },
      { text: 'thd_ib', value: 'thd_ib' },
      { text: 'thd_ic', value: 'thd_ic' },
      { text: 'thd_i', value: 'thd_i' },
      { text: 'thd_va', value: 'thd_va' },
      { text: 'thd_vb', value: 'thd_vb' },
      { text: 'thd_vc', value: 'thd_vc' },
      { text: 'thd_v', value: 'thd_v' },
      { text: 'h3_ia', value: 'h3_ia' },
      { text: 'h3_ib', value: 'h3_ib' },
      { text: 'h3_ic', value: 'h3_ic' },
      { text: 'h3_va', value: 'h3_va' },
      { text: 'h3_vb', value: 'h3_vb' },
      { text: 'h3_vc', value: 'h3_vc' },
      { text: 'h5_ia', value: 'h5_ia' },
      { text: 'h5_ib', value: 'h5_ib' },
      { text: 'h5_ic', value: 'h5_ic' },
      { text: 'h5_va', value: 'h5_va' },
      { text: 'h5_vb', value: 'h5_vb' },
      { text: 'h5_vc', value: 'h5_vc' },
      { text: 'h7_ia', value: 'h7_ia' },
      { text: 'h7_ib', value: 'h7_ib' },
      { text: 'h7_ic', value: 'h7_ic' },
      { text: 'h7_va', value: 'h7_va' },
      { text: 'h7_vb', value: 'h7_vb' },
      { text: 'h7_vc', value: 'h7_vc' }
    ];
    const allWaterParams = [
      { text: 'Flow Rate', value: 'flowrate' },
      { text: 'Total Flow', value: 'totalflow' }
    ];
    const paramTemperature = { text: 'Temperature', value: 'ambient_temp' };
    const paramPressure = { text: 'Pressure', value: 'ambient_pressure' };
    const paramCFMOutput = { text: 'CFM Output', value: 'CFM' };
    const fuelParam = { text: 'Fuel Consumption', value: 'fuelConsumption' };
    const irdSensorOutput = {
      text: 'Irradiation Sensor Output',
      value: 'IrradiationSensorOutput'
    };
    if (forAlertConfig === true) {
      allElectricalParams = [
        // 'On Duration',
        'Energy',
        'Real Time Power',
        'Voltage',
        'Current',
        'Power Factor' /* 'Shiftwise Energy' */
      ];
    } else {
      allElectricalParams = [
        { text: 'current', value: 'current' },
        { text: 'currentA', value: 'currentA' },
        { text: 'currentB', value: 'currentB' },
        { text: 'currentC', value: 'currentC' },
        { text: 'voltage', value: 'voltage' },
        { text: 'voltageA', value: 'voltageA' },
        { text: 'voltageB', value: 'voltageB' },
        { text: 'voltageC', value: 'voltageC' },
        { text: 'powerfactor', value: 'powerfactor' },
        { text: 'powerfactorA', value: 'powerfactorA' },
        { text: 'powerfactorB', value: 'powerfactorB' },
        { text: 'powerfactorC', value: 'powerfactorC' },
        { text: 'realtimepower', value: 'realtimepower' },
        { text: 'realtimeenergy', value: 'realtimeenergy' },
        { text: 'registerenergy', value: 'registerenergy' },
        { text: 'Shiftwaise Energy', value: 'shiftwaiseenergy' }
      ];
    }
    otherParams = [
      paramTemperature,
      paramPressure,
      paramCFMOutput,
      fuelParam,
      irdSensorOutput
    ];
    if (load.parameters != null) {
      for (let j = 0; j < load.parameters.length; j++) {
        const param = load.parameters[j];
        switch (param.name) {
          case Constants.LOAD_PARAM.ALL_ELECTRICAL:
            const temp = allElectricalParams.map((x: any) => ({
              text: x,
              value: x
            }));
            loadParamArr = loadParamArr.concat(temp);
            break;
          case Constants.LOAD_PARAM.TEMPERATURE:
            loadParamArr.push(paramTemperature);
            loadParamArr = loadParamArr.concat(irdSensorOutput);
            break;
          case Constants.LOAD_PARAM.PRESSURE:
            loadParamArr.push(paramPressure);
            break;
          case Constants.LOAD_PARAM.FLOW_OUTPUT:
            loadParamArr.push(paramCFMOutput);
            loadParamArr.push(fuelParam);
            break;
          case Constants.LOAD_PARAM.ALL_HARMONIC:
            loadParamArr = loadParamArr.concat(allHarmonicParams);
            break;
          case Constants.LOAD_PARAM.ALL_WATER:
            loadParamArr = loadParamArr.concat(allWaterParams);
            break;
          default:
            if (forAlertConfig === true) {
              loadParamArr.push({ text: param.name, value: param.name });
            }
        }
      }
    }
    if (loadParamArr.length === 0) {
      loadParamArr = allElectricalParams.concat(otherParams);
    }
    return loadParamArr;
  };

  getParameterSelectedLoad(event) {
    this.parameters = [];
    let loadIds = [];
    let siteId = '';
    if (
      this.nodeDetails &&
      this.nodeDetails.selectedLoadEntity !== null &&
      this.nodeDetails.selectedLoadEntity !== undefined &&
      this.nodeDetails.selectedLoadEntity !== ''
    ) {
      this.loads
        .filter((load) => {
          return load.loadId === this.nodeDetails.selectedLoadEntity;
        })
        .map((param) => {
          this.parameters = param.paramArr;
        });
      this.nodeDetails.loadID = this.nodeDetails.selectedLoadEntity;
      siteId = this.siteId;
      loadIds.push(this.nodeDetails.loadID);
    }

    if (
      this.nodeDetails.selectedLoadEntity !== null &&
      this.nodeDetails.selectedLoadEntity !== '' &&
      this.siteId
    ) {
      this.nodeDetails.selectedEnity = this.nodeDetails.selectedLoadEntity;

      this.loadService
        .getMetersFromLoadIds({ loadIds, siteId })
        .subscribe((meters) => {
          if (meters !== null || meters !== undefined) {
            this.nodeDetails.meterId = meters[0].meterId;
            this.nodeDetails.kpiName = meters[0].kpiName;
            this.generateStaticNodeIdForMeter(
              this.nodeDetails.meterId,
              this.nodeDetails.monitoredParameter
            );
          }
        });
    }
    this.nodeDetails.assignSensor = false;
  }

  generateMeterNoadeId() {
    this.nodeDetails.nodeId = this.generateStaticNodeIdForMeter(
      this.nodeDetails.meterId,
      this.nodeDetails.monitoredParameter
    );
  }

  generateNodeIdForSensor() {
    if (this.nodeDetails) {
      this.nodeDetails.nodeId = this.nodeDetails.sensorRIdForSelectedEnity;
    }
    this.nodeDetails.assignSensor = true;
  }

  getSensorsConnectedToGenericLoad() {
    const params = {
      siteID: this.siteId,
      type: Constants.LOAD_TYPE.GENERIC_OR_AREA_SPECIFIC_SENSOR.TYPE_VALUE,
      loadId: this.nodeDetails.selectedEnity
    };
    this.loadService.getSensorDetailsBasedOnLoadId(params).subscribe((data) => {
      const sensorsConnectedToGenericLoad = [];
      if (data.Inlets != null && data.Inlets.length > 0) {
        for (let i = 0; i < data.Inlets.length; i++) {
          sensorsConnectedToGenericLoad.push({
            Title: data.Inlets[i].name,
            sensorNodeId: this.generateStaticNodeIdForSensor(
              data.Inlets[i].sensor.id
            )
          });
        }
      }
      this.sensorConnectedToGenericLoad = sensorsConnectedToGenericLoad;
    });
    this.nodeDetails.assignSensor = false;
  }

  generateStaticNodeIdForSensor(id: string) {
    let result = 'sensor_' + id + '_';
    let timeStamp = Date.now();
    let randomNumber = Math.floor(Math.random() * 1000);

    return result + timeStamp + '_' + randomNumber;
  }

  generateStaticNodeIdForMeter(meterId: string, monitoredParameter: string) {
    if (meterId !== '' && meterId !== null) {
      let result = 'meter_' + meterId + '_' + monitoredParameter + '_';
      let timeStamp = Date.now();
      let randomNumber = Math.floor(Math.random() * 1000);

      return result + timeStamp + '_' + randomNumber;
    }
  }

  public startWhitespace(control: UntypedFormControl) {
    if (
      (control.value as string) &&
      (control.value as string).indexOf(' ') == 0
    ) {
      return { whitespace: true };
    }
    return null;
  }
}
